import { styled } from '@mui/system';
import { Divider as DividerMUI } from '@mui/material';
import BillzTypographyTitle from '../../components/BillzTypographies/BillzTypographyTitle';
import { Stack as StackMUI, Card as CardMUI } from '@mui/material';
import { Grid as GridMui } from '@mui/material';
import { theme } from 'oems/theme';
import MDButton from 'components/MDButton';

export const Divider = styled(DividerMUI)`
  margin: 30px 0;
`;

export const HiddenDivider = styled('div')`
  margin: 10px 10px;
`;

export const Actions = styled('div')`
  margin-top: 40px;
`;

export const BillzTitle = styled(BillzTypographyTitle)`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h3 = styled('h3')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  text-align: left;
  height: 100%;
  font-size: 14px;
  line-height: 17.5%;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h3h = styled('h3')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  text-align: left;
  height: 100%;
  font-size: 14px;
  line-height: 17.5%;
  margin-top: 2px;
  margin-bottom: 2px;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h4 = styled('h4')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  vertical-align: bottom;
  line-height: 17.5%;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h2 = styled('h2')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h5 = styled('h5')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const h6 = styled('h6')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const h6b = styled('h6')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const Stack = styled(StackMUI)`
  justify-content: center;
  height: 30px;
  margin-top: 20px;
`;

export const Grid = styled(GridMui)`
  padding-left: 20px;
`;

export const TitleBox = styled(StackMUI)`
  margin-top: 50px;
  margin-bottom: 20px;
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  border: 1px solid ${theme.palette.border.light};
  border-radius: 8px;
`;

export const Row = styled('div')`
  display: flex;
  gap: 24px;

  .smallInput {
    width: 136px;
    flex-shrink: 0;
  }

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    .smallInput {
      width: 75px;
    }
  }

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;

    .smallInput {
      width: 100%;
    }
  }
`;

export const Menu = styled('div')`
  position: sticky;
  top: 20px;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;

  .menuItem {
    button {
      width: 100%;
      padding: 0 14px;

      &:hover {
        background: ${theme.palette.background.default} !important;
      }

      .label {
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        white-space: pre;
        color: ${theme.palette.text.dark};
        width: 100%;
        display: flex;
        justify-content: flex-start;

        svg {
          margin-right: 12px;
          width: 26px;
          height: 26px;
        }
      }
    }
  }
`;

export const NavigationButton = styled(MDButton)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  vertical-align: left;
  text-transform: none;
  justify-content: left;
  background-color: ${theme.palette.border.light};
  color: ${theme.palette.buttonText.contrast};

  box-shadow: none;
`;

export const SideCard = styled(CardMUI)`
  padding: 1rem 1rem;
  width: 20rem;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
`;
